<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "delete-popup",
        "hide-footer": "",
        centered: "",
        size: "380",
        "no-close-on-backdrop": true,
      },
      on: {
        hide: function ($event) {
          return _vm.closeModal()
        },
      },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "icon-bg delete-bg head-top-15" },
        [_c("feather-icon", { attrs: { icon: "Trash2Icon", size: "38" } })],
        1
      ),
      _c("h4", { staticClass: "mb-1 text-center" }, [
        _vm._v(_vm._s(_vm.$t("payment.are-you-sure-delete"))),
      ]),
      _c(
        "div",
        { staticClass: "d-block text-center mt-2 mb-1" },
        [
          _c(
            "b-button",
            {
              staticClass: "min-120-btn",
              attrs: { variant: "primary" },
              on: {
                click: function ($event) {
                  return _vm.deleteApi(_vm.id)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("payment.Confirm-delete")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/DeletePopup.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"]
  },
  data() {
    return {
      modalVisible: this.isDeletePaymentPop
    };
  },
  watch: {
    isDeletePaymentPop(newValue) {
      this.modalVisible = newValue;
    }
  },
  methods: {
    closeModal() {
      this.modalVisible = false;
      this.closePaymentPop();
    }
  },
  props: {
    isDeletePaymentPop: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    id: {
      default: ""
    },
    closePaymentPop: {
      type: Function,
      isRequired: false,
      default: () => {}
    },
    deleteApi: {
      type: Function,
      isRequired: false,
      default: () => {}
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/DeletePopup.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
#delete-popup .modal-380 {
  max-width: 380px;
}
</style>
